export enum SessionStorageEnum {
  session = "session"
}